<template>
  <v-dialog max-width="550px" v-model="dialog" @keydown.enter.prevent="save">
    <v-card>
      <v-card-title>
        <span class="headline">Recycle Config</span>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="4" md="4">
            <r-item-recycle-mode :model.sync="mode"/>
          </v-col>
        </v-row>
        <v-row dense class="pt-4">
          <v-expansion-panels v-model="panels">
            <r-reward-panel :disabled="mode.id < 2" :model.sync="model.reward" title="Rewards"/>
          </v-expansion-panels>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>Cancel</v-btn>
        <v-btn @click="save" color="blue darken-1" text>Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {ItemRecycleConfig} from "@/modules/redactor/models/item/recycle/ItemRecycleConfig";
import {ItemRecycleMode} from "@/modules/redactor/models/item/recycle/ItemRecycleMode";

import RRewardPanel from "@/modules/redactor/views/reward/r-reward-panel.vue";
import RItemRecycleMode from "@/modules/redactor/views/item/recycle/r-item-recycle-mode.vue";

export default {
  name: "r-item-recycle-config",
  components: {RItemRecycleMode, RRewardPanel},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new ItemRecycleConfig(),
    rules: ViewRules.READONLY,
    panels: []
  }),
  computed: {
    mode: {
      get: function () {
        return this.model ? this.model.mode : ItemRecycleMode.DISABLED;
      },
      set: function (value) {
        this.model.mode = value;
      }
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new ItemRecycleConfig();
      this.panels = [];
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.empty()) {
        this.resolve(null);
        this.discard();
      } else if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    }
  },
  watch: {
    mode() {
      this.panels = [];
    }
  },
}
</script>